import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'
import RemoteDesktopControlPermissionDialogContent from '../../dialogs/RemoteDesktopControlPermissionDialogContent'

function RemoteDesktopControlPermisionDecisionPopup({
    fromUsername,
    onResult,
    onClose,
}: {
    fromUsername: string
    onResult: (isAllowed: boolean) => void
    onClose: () => void
}) {
    return (
        <CrossPlatformDialog
            frameName="Dialog:RemoteDesktopControlPermisionDecisionPopup"
            onDefaultClose={() => onClose()}
        >
            <RemoteDesktopControlPermissionDialogContent
                requesterName={fromUsername}
                onAccept={() => onResult(true)}
                onDeny={() => onResult(false)}
            />
        </CrossPlatformDialog>
    )
}

export default RemoteDesktopControlPermisionDecisionPopup
